import React, { useRef, useEffect } from "react";
import { Text, View, Animated } from "react-native";
import Svg, { Circle, Defs, G, LinearGradient, Stop } from "react-native-svg";
import { useSelector } from "react-redux";
import metrics from "../../constants/metrics";

const AnimatedCircle = Animated.createAnimatedComponent(Circle);

const Stat = (props) => {
  const {
    percentage,
    title,
    subTitle,
    allowEmpty,
    children,
    disabled = false,
    circleWidth = metrics.screenWidth,
    fillColor,
    rotate = "160deg",
  } = props;
  const width = circleWidth / 2;

  const pieWidth = width - 30;
  const circumference = 2 * Math.PI * (pieWidth / 2);
  const strokeWidth = 10;
  const radius = pieWidth / 2;
  const halfCircle = radius + strokeWidth;

  const circleRef = useRef();
  const animatedValue = useRef(new Animated.Value(0)).current;

  const animation = (toValue) =>
    Animated.timing(animatedValue, {
      toValue,
      duration: 800,
      delay: 0,
      useNativeDriver: true,
    }).start(() => {
      animatedValue.removeAllListeners();
    });

  useEffect(() => {
    setTimeout(() => {
      animation(percentage);
    }, 220);
    animatedValue.addListener(({ value }) => {
      if (circleRef?.current) {
        const maxPerc = Math.min((100 * value) / 100, 100);
        const strokeDashoffset =
          circumference - (circumference * maxPerc) / 100;
        circleRef.current.setNativeProps({
          strokeDashoffset,
        });
      }
    });
    return () => animatedValue.removeAllListeners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [percentage]);

  return (title && subTitle) || allowEmpty ? (
    <>
      <View
        style={{
          // padding: 15,
          borderRadius: 100,
          backgroundColor: "white",
          overflow: "visible",
          alignItems: "center",
          position: "relative",
          transform: [
            // { translateX:  },
            { rotate: `-${rotate}` },
          ],
        }}
      >
        <Svg
          height={radius * 2}
          width={radius * 2}
          viewBox={`0 0 ${halfCircle * 2} ${halfCircle * 2}`}
        >
          <Defs>
            <LinearGradient
              id="prefix__a"
              gradientUnits="userSpaceOnUse"
              x1={88}
              y1={0}
              x2={88}
              y2={176}
            >
              <Stop
                offset={0}
                stopColor={
                  fillColor ||
                  (disabled
                    ? "#e5e5e5"
                    : percentage === 100
                      ? "#00AB59"
                      : "#F25700")
                }
              />
              <Stop
                offset={1}
                stopColor={
                  fillColor ||
                  (disabled
                    ? "#e5e5e5"
                    : percentage === 100
                      ? "#00AB59"
                      : "#F25700")
                }
              />
            </LinearGradient>
          </Defs>
          <G rotation="-90" origin={`${halfCircle}, ${halfCircle}`}>
            <Circle
              cx="50%"
              cy="50%"
              strokeWidth={strokeWidth}
              stroke="#E5E5E5"
              r={radius}
              fill="transparent"
              strokeOpacity={0.5}
            />
            <AnimatedCircle
              ref={circleRef}
              cx="50%"
              cy="50%"
              strokeWidth={strokeWidth}
              stroke="url(#prefix__a)"
              r={radius}
              fill="transparent"
              strokeDasharray={circumference}
              strokeDashoffset={circumference}
              strokeLinecap="butt"
            />
          </G>
        </Svg>

        <View
          style={{
            width,
            height: width,
            justifyContent: "center",
            position: "absolute",
            alignItems: "center",
            left: -15,
            top: -15,
            transform: [
              // { perspective: 850 },
              // { translateX:  },
              { rotate },
            ],
          }}
        >
          {children}
          {/* <Text
            style={{
              color: disabled ? "#B3B3B3" : "black",
              textAlign: "center",
              width: "60%",
              fontFamily: "NotoSansDevanagari-Bold",
              fontSize: 20,
            }}>
            {title}
          </Text>
          <Text
            style={{
              fontSize: 12,
              textAlign: "center",
              color: disabled ? "#B3B3B3" : "rgba(0,0,0,0.56)",
              fontFamily: "NotoSansDevanagari-Regular",
              width: "60%",
            }}>
            {subTitle}
          </Text> */}
        </View>
      </View>
    </>
  ) : null;
};

export default Stat;
